import type { Dayjs } from "dayjs";

export const isWeekend = (date: Dayjs): boolean => {
	const day = date.day();
	return day === 0 || day === 6;
};
